export default class facebookPages {
    constructor() {
        return {
            scope: {
                pages: "="
            },
            template: require('../../../views/facebook/settings-widget.html'),
            controller: PagesCtrl,
            controllerAs: 'fb'
        }    
    }
};

class PagesCtrl {
    constructor(FacebookService, Facebook, Events, $filter) {
        this.fbService = FacebookService;
        this.fbRepo = Facebook;
        
        this.fbService.init();
        this.updateSubscribedPages();
        this.eventsHandler = Events;
        this._filter = $filter;
        
        this.pages = [];
        this.accessToken = null;
        this.userId = null;
    }
    
    updateSubscribedPages() {
        this.fbRepo.getPages().then((pages) => {
            pages.data.map((page) => {
                page.subscribed = true;
            });

            this.pages = pages.data;
        });
    };

    loginAndGetPages() {
        let getPagesFromFb = () => {
            this.fbRepo.getFacebookPages(this.accessToken).then((pages) => {
                this.fetchedFromFacebook = pages.data;
                this.updatePageSubscriptions();
            });
        };

        let callback = (response) => {
            if (response.status === 'connected') {
                this.accessToken = response.authResponse.accessToken;
                this.userId = response.authResponse.userID;
                getPagesFromFb();
            }
        };

        this.fbService.login(callback);
    };

    subscribeApp(page) {
        let pageId = page.fb_page_id || page.id;
        let userId = this.userId || null;

        if (! page.subscribed) {
            this.fbService.unsubscribeApp(pageId, page.access_token, (response) => {
                if (response.error) {
                    this.eventsHandler.flashEvent(
                        'error',
                        this._filter('translate')('SETTING:FACEBOOK:DELETE:PAGE:ERROR')
                    );
                } else {
                    this.fbRepo.deletePage(pageId).catch((error) => {
                        this.eventsHandler.flashEvent(
                            'error',
                            this._filter('translate')('SETTING:FACEBOOK:DELETE:PAGE:ERROR')
                        );
                    });
                }
            });
        } else {
            this.fbService.subscribeApp(pageId, page.access_token, (response) => {
                if (response.error) {
                    this.eventsHandler.flashEvent(
                        'error',
                        this._filter('translate')('SETTING:FACEBOOK:REQUEST:ERROR')
                    );
                } else {
                    page.user_id = page.user_id || userId;
                    page.id = pageId;
                    this.fbRepo.storePage(page).catch((error) => {
                        //if page exists backend returns 409 code
                        if (error.status === 409) {
                            this.eventsHandler.flashEvent(
                                'error',
                                this._filter('translate')('SETTING:FACEBOOK:PAGE:EXISTS:ERROR')
                            );
                        } else {
                            this.eventsHandler.flashEvent(
                                'error',
                                this._filter('translate')('SETTING:FACEBOOK:REQUEST:ERROR')
                            );
                        }
                    });
                }
            });
        }
    };

    updatePageSubscriptions() {
        let subscribedFbPageIds = this.pages.map((page) => {
            if (page.subscribed) {
                return parseInt(page.fb_page_id) || parseInt(page.id);
            }
        });

        this.pages = this.fetchedFromFacebook.map((page) => {
            page.subscribed = false;
            if (subscribedFbPageIds.indexOf(parseInt(page.id)) !== -1) {
                page.id = parseInt(page.id);
                page.subscribed = true;
            }

            return page;
        });
    };
}
